import { latest } from "../lib/atom-crdt"
import { test, expect, is } from "@benchristel/taste"
import { BallotBox, ballot } from "./PollCRDT"

export function mergeBallots(a: BallotBox, b: BallotBox): BallotBox {
  return [...new Set([...Object.keys(a), ...Object.keys(b)])].reduce(
    (merged, agent) => ({
      ...merged,
      [agent]: latest(ballot(a, agent), ballot(b, agent), ballotTiebreaker),
    }),
    {},
  )
}
test("ballotTiebreaker", {
  "breaks ties by first candidate ID"() {
    expect(
      ballotTiebreaker(["foo"], ["bar"]),
      is,
      !ballotTiebreaker(["bar"], ["foo"]),
    )
  },

  "breaks ties by length"() {
    expect(ballotTiebreaker([], ["bar"]), is, !ballotTiebreaker(["bar"], []))
  },

  "breaks ties between no candidates and empty string"() {
    expect(ballotTiebreaker([], [""]), is, !ballotTiebreaker([""], []))
  },

  "breaks ties between a candidate and the empty string"() {
    const a = ["one", ""]
    const b = ["", "one"]
    expect(ballotTiebreaker(a, b), is, !ballotTiebreaker(b, a))
  },

  "breaks ties between ballots whose first-choice candidates are the same"() {
    const a = ["one", "two"]
    const b = ["one", "three"]
    expect(ballotTiebreaker(a, b), is, !ballotTiebreaker(b, a))
  },

  "breaks ties between ballots whose second-choice candidates are the same"() {
    const a = ["one", "two", "three"]
    const b = ["one", "two", "four"]
    expect(ballotTiebreaker(a, b), is, !ballotTiebreaker(b, a))
  },
})
function ballotTiebreaker(a: string[], b: string[]): boolean {
  if (a.length === b.length)
    for (let i = 0; i < a.length; i++) {
      const ai = a[i]
      const bi = b[i]
      if (ai === bi) continue
      return Boolean(ai != null && bi != null && ai > bi)
    }

  return a.length > b.length
}
